import React from 'react'
import CentsLogo from '../../cents/CentsLogo'
import { CentsPalette } from '../../../utils/colors'
import { LanguageSelector } from '../translations/LanguageSelector'
import UserProfile from './UserProfile'


const Footer: React.FC = () => {
  return (
    <footer className='footer flex flex-col h-fit w-full gap-5 md:pb-5'>
      <UserProfile />
      <LanguageSelector />
      <div className='footer-logo flex items-end justify-end h-fit'>
        <span className='relative top-[2px] mr-1 text-cents-black text-xs'>by</span>
        <CentsLogo height={24} color={CentsPalette.cents_black} />
      </div>
    </footer>
  )
}

export default Footer